import { EFieldType } from '@shared/enums/EFieldType';
import { toFormMeta } from '@shared/configurable/field-registry';
import { IFieldDef } from '@shared/configurable/models/IFieldDef';

/** Single source of truth for the Insurance finance fields (see field-registry.ts). */
export const INSURANCE_FINANCE_FIELDS: IFieldDef[] = [
  {
    key: 'insuranceAnnualPremium',
    form: { controlName: 'annualPremium', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 1, order: 0 },
  },
  {
    key: 'insuranceFees',
    form: { controlName: 'annualFees', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 1, order: 1 },
  },
  {
    key: 'totalExTax',
    form: { controlName: 'annualNetTotal', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 1, order: 2 },
  },
  {
    key: 'insuranceTaxes',
    form: { controlName: 'annualTaxes', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 1, order: 3 },
  },
  {
    key: 'insuranceAnnualTotal',
    form: { controlName: 'annualTotal', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 1, order: 4 },
  },
  {
    key: 'insuranceWrittenPremium',
    form: { controlName: 'writtenPremium', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 2, order: 0 },
  },
  {
    key: 'insuranceWrittenTaxes',
    form: { controlName: 'writtenTaxes', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 2, order: 1 },
  },
  {
    key: 'insuranceWrittenFees',
    form: { controlName: 'writtenFees', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 2, order: 2 },
  },
  {
    key: 'insuranceWrittenTotal',
    form: { controlName: 'writtenTotal', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 2, order: 3 },
  },
  {
    key: 'insuranceMoney1',
    form: { controlName: 'localizedMoney1', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 3, order: 0 },
  },
  {
    key: 'insuranceVarMoney2',
    form: { controlName: 'localizedMoney2', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 3, order: 1 },
  },
  {
    key: 'insuranceVarMoney3',
    form: { controlName: 'localizedMoney3', type: EFieldType.Money, dontReplaceZero: true },
    formDefault: { group: 0, row: 1, column: 3, order: 2 },
  },
  {
    key: 'insuranceAgent',
    form: { controlName: 'idAgent', type: EFieldType.Dropdown, optionLabel: 'name', optionValue: 'id' },
    formDefault: { group: 0, row: 1, column: 3, order: 3 },
  },
  {
    key: 'commissionPercentage',
    form: { controlName: 'agentCommissionPercentage', type: EFieldType.Money, dontReplaceZero: true, fractionSize: 4, suffix: '%' },
    formDefault: { group: 0, row: 1, column: 3, order: 4 },
  },
  {
    key: 'insuranceContractFeePercentage',
    form: {
      controlName: 'contractFeePercentage',
      type: EFieldType.Money,
      dontReplaceZero: true,
      fractionSize: 4,
      suffix: '%',
      errors: { min: 'Min value 0', max: 'Max value 100' },
    },
    formDefault: { group: 0, row: 1, column: 3, order: 5 },
  },
  {
    key: 'currency',
    form: { controlName: 'currency', type: EFieldType.Dropdown, optionValue: 'text' },
    formDefault: { group: 0, row: 1, column: 4, order: 0 },
  },
  {
    key: 'insuranceInstalments',
    form: { controlName: 'instalments', type: EFieldType.Dropdown, optionValue: 'text' },
    formDefault: { group: 0, row: 1, column: 4, order: 1 },
  },
  {
    key: 'policyInvoiceExempt',
    noRequiredToggle: true,
    form: { controlName: 'invoicingExempt', type: EFieldType.Switch },
    formDefault: { group: 0, row: 1, column: 4, order: 2 },
  },
  {
    key: 'policyReminderExempt',
    noRequiredToggle: true,
    form: { controlName: 'reminderExempt', type: EFieldType.Switch },
    formDefault: { group: 0, row: 1, column: 4, order: 3 },
  },
  {
    key: 'insuranceOneTimeIncome',
    noRequiredToggle: true,
    form: { controlName: 'oneOffIncome', type: EFieldType.Switch },
    formDefault: { group: 0, row: 1, column: 4, order: 4 },
  },
  {
    key: 'net_Agent',
    noRequiredToggle: true,
    form: { controlName: 'netBroker', type: EFieldType.Switch },
    formDefault: { group: 0, row: 1, column: 4, order: 5 },
  },
  {
    key: 'insuranceDirectDebit',
    noRequiredToggle: true,
    form: { controlName: 'directDebit', type: EFieldType.Switch },
    formDefault: { group: 0, row: 1, column: 4, order: 6 },
  },
  {
    key: 'insuranceAutoBilling',
    noRequiredToggle: true,
    form: { controlName: 'automatedBilling', type: EFieldType.Switch },
    formDefault: { group: 0, row: 1, column: 4, order: 7 },
  },
];

export const INSURANCE_FINANCE_META = toFormMeta(INSURANCE_FINANCE_FIELDS);
